/* built from src/js/component-modal-gridy-slider.js - edit the source, not this file */
customElements.get("modal-gridy-slider-parent")||customElements.define("modal-gridy-slider-parent",class extends HTMLElement{constructor(){super(),document.querySelector("#MainContent").appendChild(this)}});
